function toggleMenu(){
	var filterWrapper = document.querySelector('.bc-sf-filter-left-col');
    var isOpen = filterWrapper.classList.contains('open');
    if(isOpen){
        closeFilter()
    }else {
        openFilter();
    }
}

function closeFilter(){
    var filterTrees = document.getElementById('bc-sf-filter-tree');
	var filterWrapper = document.querySelector('.bc-sf-filter-left-col');
  	filterWrapper.classList.remove('open');
    filterTrees.classList.remove('bc-sf-filter-tree-mobile-open');
}

function openFilter(){
	var filterWrapper = document.querySelector('.bc-sf-filter-left-col');
  	filterWrapper.classList.add('open');
}

document.addEventListener("click", function(e){
  var target = e.target;
  var id = e.target.id || '';
  var parentID = target.parentNode.id || '';
  if(id === 'bc-sf-filter-tree-mobile-button' || parentID === 'bc-sf-filter-tree-mobile-button'){
    toggleMenu();
  }else if(id === 'btn-close-filter' || parentID === 'btn-close-filter'){
  	closeFilter();
  }else if(target.classList.contains('bc-sf-filter-see-result')){
  	closeFilter();
    var toolbar = document.getElementById('bc-sf-filter-default-toolbar');
    window.scroll({
      top: toolbar.offsetTop - 120, 
      left: 0, 
      behavior: 'smooth' 
	});
  }
});